import { Box, BoxProps } from '@chakra-ui/react'
import * as React from 'react'

import SoundSetting from './SoundSetting'

export type IntroProps = BoxProps & {}

const Intro: React.FC<IntroProps> = ({ ...others }) => {
  return (
    <>
      <Box pos="fixed" {...others}>
        <SoundSetting />
      </Box>
    </>
  )
}

export default Intro
